import { Component, Inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { firstValueFrom } from 'rxjs';
import { ActivityImprovedService } from 'src/api/activity/activity-improved/activity-improved.service';
import { DoenkidsSessionProvider } from 'src/providers/session.provider';
import { IServiceResponse } from 'typings/api-generic';
import dayjs from 'dayjs';

interface IImprovedActivity {
  organization_unit_id: number;
  organization_unit_name: string;
  show_until: Date;
}
@Component({
    selector: 'app-add-activity-improved-dialog',
    templateUrl: './add-activity-improved-dialog.component.html',
    styleUrls: ['./add-activity-improved-dialog.component.scss'],
    standalone: false
})
export class AddActivityImprovedDialogComponent {
  public showUntil: FormControl = new FormControl(dayjs().add(1, 'month').toDate());

  private removedOrganizationUnitIds: number[] = [];

  public get improvedActivities(): IImprovedActivity[] {
    return this.data.improvedActivities?.filter((activity) => {
      return !this.removedOrganizationUnitIds.includes(activity.organization_unit_id);
    }) || [];
  }

  constructor(
    public dialogRef: MatDialogRef<AddActivityImprovedDialogComponent>,
    private $session: DoenkidsSessionProvider,
    private $activityImprovedService: ActivityImprovedService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      activityId: number;
      improvedActivities?: IImprovedActivity[];
    },
  ) {
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  async removeActivityImproved(organizationUnitID: number): Promise<IServiceResponse> {
    this.dialogRef.close();
    const result = await this.$activityImprovedService.remove(organizationUnitID, this.data.activityId);

    this.removedOrganizationUnitIds.push(organizationUnitID);
    return result;
  }

  async onOkClick(): Promise<void> {
    this.dialogRef.close(this.showUntil.value);
    const organizationUnitId = (await firstValueFrom(this.$session.getOrganizationUnit$)).id;
    await this.$activityImprovedService.update(organizationUnitId, this.data.activityId, this.showUntil.value);
  }
}
